import * as actions from '../actions'

var defaultState = null

export default function saveAssetForTelegram(state = defaultState, action) {
    switch (action.type) {
        case actions.SAVE_ASSET_TELEGRAM:
            var newState = state
            if (!action.error) {
                newState = defaultState
            }
            return newState
        case actions.CLEAN_SAVE_ASSET_TELEGRAM:
            return defaultState
        default:
            return state
    }
}
